import { render, staticRenderFns } from "./CustomerNewreg.vue?vue&type=template&id=5afc2ab0&"
import script from "./CustomerNewreg.vue?vue&type=script&lang=js&"
export * from "./CustomerNewreg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5afc2ab0')) {
      api.createRecord('5afc2ab0', component.options)
    } else {
      api.reload('5afc2ab0', component.options)
    }
    module.hot.accept("./CustomerNewreg.vue?vue&type=template&id=5afc2ab0&", function () {
      api.rerender('5afc2ab0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/CustomerNewreg.vue"
export default component.exports